<template>
  <div class="px-20 px-sm-40 py-30 py-sm-40">
    <nuxt-child />
  </div>
</template>

<script>
  export default {
    layout: 'auth',
  }
</script>
